import Vue from 'vue'
import Router from 'vue-router'

import BlogCategories from '@/components/pages/blog/categories/pages/Index'
import CreateBlogCategory from '@/components/pages/blog/categories/pages/Create'
import EditBlogCategories from '@/components/pages/blog/categories/pages/Edit'
import BlogArticles from '@/components/pages/blog/articles/pages/Index'
import CreateBlogArticle from '@/components/pages/blog/articles/pages/Create'
import EditBlogArticle from '@/components/pages/blog/articles/pages/Edit'

import ActivityCategories from '@/components/pages/activity/categories/pages/Index'
import CreateActivityCategory from '@/components/pages/activity/categories/pages/Create'
import EditActivityCategories from '@/components/pages/activity/categories/pages/Edit'
import ActivityArticles from '@/components/pages/activity/articles/pages/Index'
import CreateActivityArticle from '@/components/pages/activity/articles/pages/Create'
import EditActivityArticle from '@/components/pages/activity/articles/pages/Edit'

import Authors from '@/components/pages/authors/pages/Index'
import CreateAuthor from '@/components/pages/authors/pages/Create'
import EditAuthor from '@/components/pages/authors/pages/Edit'

import Albums from '@/components/pages/albums/pages/Index'
import CreateAlbum from '@/components/pages/albums/pages/Create'
import EditAlbum from '@/components/pages/albums/pages/Edit'

import Reviews from '@/components/pages/reviews/common/pages/Index'
import CreateReview from '@/components/pages/reviews/common/pages/Create'
import EditReview from '@/components/pages/reviews/common/pages/Edit'
import ReviewsPublications from '@/components/pages/reviews/publications/pages/Index'
import EditReviewPublication from '@/components/pages/reviews/publications/pages/Edit'
import ReviewsScientist from '@/components/pages/reviews/scientist/pages/Index'
import EditReviewScientist from '@/components/pages/reviews/scientist/pages/Edit'

import SeminarsCategories from '@/components/pages/seminars/categories/pages/Index'
import CreateSeminarsCategory from '@/components/pages/seminars/categories/pages/Create'
import EditSeminarsCategories from '@/components/pages/seminars/categories/pages/Edit'
import SeminarsArticles from '@/components/pages/seminars/articles/pages/Index'
import CreateSeminarsArticle from '@/components/pages/seminars/articles/pages/Create'
import EditSeminarsArticle from '@/components/pages/seminars/articles/pages/Edit'

import SeminarsFreeArticles from '@/components/pages/kruglyj-stol/articles/pages/Index'
import CreateSeminarsFreeArticle from '@/components/pages/kruglyj-stol/articles/pages/Create'
import EditSeminarsFreeArticle from '@/components/pages/kruglyj-stol/articles/pages/Edit'

import PhotoReports from '@/components/pages/seminars/photo-reports/pages/Index'
import CreatePhotoReport from '@/components/pages/seminars/photo-reports/pages/Create'
import EditPhotoReport from '@/components/pages/seminars/photo-reports/pages/Edit'

import CoursesArticles from '@/components/pages/courses/articles/pages/Index'
import CreateCoursesArticle from '@/components/pages/courses/articles/pages/Create'
import EditCourseArticle from '@/components/pages/courses/articles/pages/Edit'

import Experts from '@/components/pages/experts/pages/Index'
import CreateExpert from '@/components/pages/experts/pages/Create'
import EditExpert from '@/components/pages/experts/pages/Edit'

import LecturesCategories from '@/components/pages/lectures/categories/pages/Index'
import CreateLecturesCategory from '@/components/pages/lectures/categories/pages/Create'
import EditLecturesCategories from '@/components/pages/lectures/categories/pages/Edit'
import LecturesArticles from '@/components/pages/lectures/articles/pages/Index'
import CreateLecturesArticle from '@/components/pages/lectures/articles/pages/Create'
import EditLectureArticle from '@/components/pages/lectures/articles/pages/Edit'

import FreeBooks from '@/components/pages/library/free-books/pages/Index'
import CreateFreeBook from '@/components/pages/library/free-books/pages/Create'
import EditFreeBook from '@/components/pages/library/free-books/pages/Edit'
import PaidBooks from '@/components/pages/library/paid-books/pages/Index'
import CreatePaidBook from '@/components/pages/library/paid-books/pages/Create'
import EditPaidBook from '@/components/pages/library/paid-books/pages/Edit'
import AudioBooks from '@/components/pages/library/audio-books/pages/Index'
import CreateAudioBook from '@/components/pages/library/audio-books/pages/Create'
import EditAudioBook from '@/components/pages/library/audio-books/pages/Edit'
import Meters from '@/components/pages/library/meters/pages/Index'
import CreateMeter from '@/components/pages/library/meters/pages/Create'
import EditMeters from '@/components/pages/library/meters/pages/Edit'

import FilmsCategories from '@/components/pages/library/films/categories/pages/Index'
import CreateFilmsCategory from '@/components/pages/library/films/categories/pages/Create'
import EditFilmsCategories from '@/components/pages/library/films/categories/pages/Edit'
import FilmsArticles from '@/components/pages/library/films/articles/pages/Index'
import CreateFilmsArticle from '@/components/pages/library/films/articles/pages/Create'
import EditFilmsArticle from '@/components/pages/library/films/articles/pages/Edit'
import RecommendedFilms from '@/components/pages/library/recommended-films/pages/Index'
import CreateRecommendedFilm from '@/components/pages/library/recommended-films/pages/Create'
import EditRecommendedFilm from '@/components/pages/library/recommended-films/pages/Edit'

import Pages from '@/components/pages/pages/pages/Index'
import EditPage from '@/components/pages/pages/pages/Edit'

import Feedbacks from '@/components/pages/feedbacks/pages/Index'
import ViewFeedback from '@/components/pages/feedbacks/pages/View'

import Quotes from '@/components/pages/quotes/pages/Index'
import CreateQuote from '@/components/pages/quotes/pages/Create'
import EditQuote from '@/components/pages/quotes/pages/Edit'

import Diplomas from '@/components/pages/diplomas/pages/Index'
import CreateDiploma from '@/components/pages/diplomas/pages/Create'
import EditDiploma from '@/components/pages/diplomas/pages/Edit'

import Partners from '@/components/pages/partners/pages/Index'
import CreatePartner from '@/components/pages/partners/pages/Create'
import EditPartner from '@/components/pages/partners/pages/Edit'
import DescriptionPages from '@/components/pages/description-pages/pages/Index'
import EditDescriptionPage from '@/components/pages/description-pages/pages/Edit'

import Contacts from '@/components/pages/contacts/Index'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/blog-categories',
      name: 'blog-categories',
      component: BlogCategories
    },
    {
      path: '/blog-categories/create',
      name: 'create-blog-category',
      component: CreateBlogCategory
    },
    {
      path: '/blog-categories/:id/edit',
      name: 'edit-blog-categories',
      component: EditBlogCategories
    },
    {
      path: '/blog',
      name: 'blog-articles',
      component: BlogArticles
    },
    {
      path: '/blog/create',
      name: 'create-blog-article',
      component: CreateBlogArticle
    },
    {
      path: '/blog/:id/edit',
      name: 'edit-blog-article',
      component: EditBlogArticle
    },
    {
      path: '/activity-categories',
      name: 'activity-categories',
      component: ActivityCategories
    },
    {
      path: '/activity-categories/create',
      name: 'create-activity-category',
      component: CreateActivityCategory
    },
    {
      path: '/activity-categories/:id/edit',
      name: 'edit-activity-categories',
      component: EditActivityCategories
    },
    {
      path: '/activity',
      name: 'activity-articles',
      component: ActivityArticles
    },
    {
      path: '/activity/create',
      name: 'create-activity-articles',
      component: CreateActivityArticle
    },
    {
      path: '/activity/:id/edit',
      name: 'edit-activity-article',
      component: EditActivityArticle
    },
    {
      path: '/authors',
      name: 'authors',
      component: Authors
    },
    {
      path: '/authors/create',
      name: 'create-author',
      component: CreateAuthor
    },
    {
      path: '/authors/:id/edit',
      name: 'edit-authors',
      component: EditAuthor
    },
    {
      path: '/albums',
      name: 'albums',
      component: Albums
    },
    {
      path: '/albums/create',
      name: 'create-album',
      component: CreateAlbum
    },
    {
      path: '/albums/:id/edit',
      name: 'edit-albums',
      component: EditAlbum
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: Reviews
    },
    {
      path: '/reviews/create',
      name: 'create-review',
      component: CreateReview
    },
    {
      path: '/reviews/:id/edit',
      name: 'edit-review',
      component: EditReview
    },
    {
      path: '/reviews/publications',
      name: 'reviews',
      component: ReviewsPublications
    },
    {
      path: '/reviews/publications/:id/edit',
      name: 'edit-review',
      component: EditReviewPublication
    },
    {
      path: '/reviews/scientist',
      name: 'reviews',
      component: ReviewsScientist
    },
    {
      path: '/reviews/scientist/:id/edit',
      name: 'edit-review',
      component: EditReviewScientist
    },
    {
      path: '/seminars-categories',
      name: 'seminars-categories',
      component: SeminarsCategories
    },
    {
      path: '/seminars-categories/create',
      name: 'create-seminars-category',
      component: CreateSeminarsCategory
    },
    {
      path: '/seminars-categories/:id/edit',
      name: 'edit-seminars-categories',
      component: EditSeminarsCategories
    },
    {
      path: '/seminars',
      name: 'seminars-articles',
      component: SeminarsArticles
    },
    {
      path: '/seminars/create',
      name: 'create-seminars-article',
      component: CreateSeminarsArticle
    },
    {
      path: '/seminars/:id/edit',
      name: 'edit-seminars-article',
      component: EditSeminarsArticle
    },
    {
      path: '/kruglyj-stol',
      name: 'seminars-articles',
      component: SeminarsFreeArticles
    },
    {
      path: '/kruglyj-stol/create',
      name: 'create-seminars-article',
      component: CreateSeminarsFreeArticle
    },
    {
      path: '/kruglyj-stol/:id/edit',
      name: 'edit-seminars-article',
      component: EditSeminarsFreeArticle
    },
    {
      path: '/photo-reports',
      name: 'photo-reports',
      component: PhotoReports
    },
    {
      path: '/photo-reports/create',
      name: 'create-photo-report',
      component: CreatePhotoReport
    },
    {
      path: '/photo-reports/:id',
      name: 'edit-photo-report',
      component: EditPhotoReport
    },
    {
      path: '/courses/',
      name: 'courses-articles',
      component: CoursesArticles
    },
    {
      path: '/courses/create',
      name: 'create-courses-article',
      component: CreateCoursesArticle
    },
    {
      path: '/courses/:id/edit',
      name: 'edit-course-article',
      component: EditCourseArticle
    },
    {
      path: '/experts',
      name: 'experts',
      component: Experts
    },
    {
      path: '/experts/create',
      name: 'create-expert',
      component: CreateExpert
    },
    {
      path: '/experts/:id/edit',
      name: 'edit-expert',
      component: EditExpert
    },
    {
      path: '/feedbacks',
      name: 'feedbacks',
      component: Feedbacks
    },
    {
      path: '/feedbacks/:id/view',
      name: 'view-feedback',
      component: ViewFeedback
    },
    {
      path: '/lectures-categories',
      name: 'lectures-categories',
      component: LecturesCategories
    },
    {
      path: '/lectures-categories/create',
      name: 'create-lectures-category',
      component: CreateLecturesCategory
    },
    {
      path: '/lectures-categories/:id/edit',
      name: 'edit-lectures-categories',
      component: EditLecturesCategories
    },
    {
      path: '/lectures',
      name: 'lectures-articles',
      component: LecturesArticles
    },
    {
      path: '/lectures/create',
      name: 'create-lectures-article',
      component: CreateLecturesArticle
    },
    {
      path: '/lectures/:id/edit',
      name: 'edit-lecture-article',
      component: EditLectureArticle
    },
    {
      path: '/library/free/',
      name: 'free-books',
      component: FreeBooks
    },
    {
      path: '/library/free/create',
      name: 'create-free-book',
      component: CreateFreeBook
    },
    {
      path: '/library/free/:id',
      name: 'edit-free-books',
      component: EditFreeBook
    },
    {
      path: '/library/paid/',
      name: 'paid-books',
      component: PaidBooks
    },
    {
      path: '/library/paid/create',
      name: 'create-paid-book',
      component: CreatePaidBook
    },
    {
      path: '/library/paid/:id',
      name: 'edit-paid-books',
      component: EditPaidBook
    },
    {
      path: '/library/audio/',
      name: 'audio-books',
      component: AudioBooks
    },
    {
      path: '/library/audio/create',
      name: 'create-audio-books',
      component: CreateAudioBook
    },
    {
      path: '/library/audio/:id',
      name: 'edit-audio-books',
      component: EditAudioBook
    },
    {
      path: '/pages',
      name: 'pages',
      component: Pages
    },
    {
      path: '/pages/:id',
      name: 'page-edit',
      component: EditPage
    },
    {
      path: '/library/meters',
      name: 'meters',
      component: Meters
    },
    {
      path: '/library/meters/create',
      name: 'create-meter',
      component: CreateMeter
    },
    {
      path: '/library/meters/:id/edit',
      name: 'edit-meters',
      component: EditMeters
    },
    {
      path: '/library/films-categories',
      name: 'films-categories',
      component: FilmsCategories
    },
    {
      path: '/library/films-categories/create',
      name: 'create-films-category',
      component: CreateFilmsCategory
    },
    {
      path: '/library/films-categories/:id/edit',
      name: 'edit-films-categories',
      component: EditFilmsCategories
    },
    {
      path: '/library/films/',
      name: 'films-articles',
      component: FilmsArticles
    },
    {
      path: '/library/films/create',
      name: 'create-films-article',
      component: CreateFilmsArticle
    },
    {
      path: '/library/films/:id/edit',
      name: 'edit-films-article',
      component: EditFilmsArticle
    },
    {
      path: '/library/recommended-films',
      name: 'recommended-films',
      component: RecommendedFilms
    },
    {
      path: '/library/recommended-films/create',
      name: 'create-recommended-film',
      component: CreateRecommendedFilm
    },
    {
      path: '/library/recommended-films/:id/edit',
      name: 'edit-recommended-films',
      component: EditRecommendedFilm
    },
    {
      path: '/quotes',
      name: 'quotes',
      component: Quotes
    },
    {
      path: '/quotes/create',
      name: 'create-quote',
      component: CreateQuote
    },
    {
      path: '/quotes/:id/edit',
      name: 'edit-quote',
      component: EditQuote
    },
    {
      path: '/diplomas',
      name: 'diplomas',
      component: Diplomas
    },
    {
      path: '/diplomas/create',
      name: 'create-diploma',
      component: CreateDiploma
    },
    {
      path: '/diplomas/:id/edit',
      name: 'edit-diploma',
      component: EditDiploma
    },
    {
      path: '/partners',
      name: 'partners',
      component: Partners
    },
    {
      path: '/partners/create',
      name: 'create-partner',
      component: CreatePartner
    },
    {
      path: '/partners/:id/edit',
      name: 'edit-partner',
      component: EditPartner
    },
    {
      path: '/description-pages',
      name: 'description-pages',
      component: DescriptionPages
    },
    {
      path: '/description-pages/:id/edit',
      name: 'edit-description-page',
      component: EditDescriptionPage
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: Contacts
    },
    {
      path: '*',
      name: '404',
      component: Error
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js